import axios from 'axios';

export function getAccountabilityRootStatus(accountabilityId) {
  return axios.get('VragensetVerantwoording/GetAccountabilityRootStatus?accountabilityId=' + accountabilityId)
    .then(response => response.data);
}
